export default {
  superAdmin: 'Super-Admin',
  businessUser: 'Business-User',
  managementAgency: 'Management-Agency',
  farmWorker: 'Farm-Worker',
  farmManager: 'Farm-Manager',
  all: 'All',
};
